<app-header></app-header>
<div class="container mx-auto my-[4rem]">
  <app-question [question]="question" [popupInfo]="question.popupInfo" [local]="true">
    <div class="flex items-center clickable-card-parent flex-wrap justify-center gap-4 my-[3rem]">
      <div
        class="clickable-card flex flex-col justify-center w-full text-center items-center cursor-pointer"
        (click)="onYesSelected()"
        (keydown)="onYesSelected()"
        [ngClass]="setClassActive(yesSelected)">
        <div class="flex flex-row items-center place-content-between">
          <p class="mr-2">{{ resource.form.yes }}</p>
        </div>
      </div>

      <div
        class="clickable-card flex flex-col justify-center w-full text-center items-center cursor-pointer"
        (click)="onNoSelected()"
        (keydown)="onNoSelected()"
        [ngClass]="setClassActive(noSelected)">
        <div class="flex flex-row items-center place-content-between">
          <p class="mr-2">{{ resource.form.no }}</p>
        </div>
      </div>
    </div>
  </app-question>
</div>

<div class="container mx-auto h-28 md:h-40">
  <app-footer class="footer"></app-footer>
</div>
<app-web-callback></app-web-callback>

<p-dialog
  [(visible)]="displayModal"
  [showHeader]="false"
  [modal]="true"
  [style]="{ width: '400px' }"
  [dismissableMask]="true">
  <p class="text-P my-5">{{ resource.etudiantage.modalText }}</p>
  <div class="flex justify-center mt-8">
    <button
      pButton
      type="button"
      class="button-NS w-full"
      [label]="resource.etudiantage.buttonText"
      (click)="nextStep()"></button>
  </div>
</p-dialog>

